import { Link } from "react-router"
import { Button } from "../components/ui/Button.js"

export function LandingPage() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", textAlign: "center", padding: "var(--space-4)" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)", maxWidth: 480 }}>
        <h1 style={{ fontSize: "var(--text-4xl)" }}>minecraft-infra</h1>
        <p style={{ color: "var(--text-muted)" }}>
          Administrá tus servidores de Minecraft sin necesidad de acceso local a la máquina.
        </p>
        {/* Single CTA: /login and /register both render the same
            username-first AuthPage flow, so there's no real up-front
            choice to offer between "log in" and "sign up" anymore. */}
        <div style={{ display: "flex", gap: "var(--space-3)", justifyContent: "center" }}>
          <Link to="/login">
            <Button>Empezar</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
